<div class="section-item">
  <div class="section-item-label">
    <app-pencil-icon
      *ngIf="iconConfig"
      [name]="iconConfig.name"
      [type]="iconConfig.type"
    ></app-pencil-icon>
    <span>{{ label }}</span>
  </div>
  <div class="section-item-value">
    <a class="related-link" [attr.data-name]="dataName" target="_blank" rel="noopener" [href]="url">
      <span class="related-link__text" [appTooltip]="text" [appTooltipPlacement]="'bottom-center'">
        {{ text }}
      </span>
    </a>
  </div>
</div>
